var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{staticClass:"FieldGroup__root"},[(_vm.label)?_c('SubHeading',{attrs:{"title":_vm.label,"icon":_vm.icon}}):_vm._e(),_c('div',{staticClass:"FieldGroup__inner"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }